export function validateCNPJ(cnpj?: string): boolean {
  if (!cnpj) {
    return false;
  }

  const b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const c = cnpj.replace(/[^\d]/g, "");

  if (c.length !== 14) {
    return false;
  }

  if (/0{14}/.test(c)) {
    return false;
  }

  let n = 0;
  for (let i = 0; i < 12; n += Number(c[i]) * b[++i]) {}
  if (c[12] !== String((n %= 11) < 2 ? 0 : 11 - n)) {
    return false;
  }

  n = 0;
  for (let i = 0; i <= 12; n += Number(c[i]) * b[i++]) {}
  if (c[13] !== String((n %= 11) < 2 ? 0 : 11 - n)) {
    return false;
  }

  return true;
}

export const formatarCNPJ = (cnpj: string): string => {
  if (!cnpj || cnpj.length !== 14) return cnpj;

  return cnpj.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5"
  );
};

export function formatCNPJ(cnpj: string): string {
  if (!cnpj || cnpj.length !== 14) return cnpj;

  return cnpj.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5"
  );
}

// Mascara progressiva (aplica pontuação conforme o usuário digita) — as duas
// funções acima só formatam string já completa com 14 dígitos.
export const maskCnpj = (value: string): string => {
  const digits = value.replace(/\D/g, "").slice(0, 14);
  return digits
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, "$1.$2.$3/$4-$5");
};
